import * as voltApi from "@te_react/volt-api/build/ooredoo.bundle.js";
export default voltApi;